import { reactive } from "vue";

export interface AppParameters {
  lang: string
}

export const AppStore = reactive({
  parameters: {
    lang: 'fr'
  }
})

export function setupAppParams(props: AppParameters) {
  Object.assign(AppStore.parameters, props);
}